export type Module = 'all' | 'returns-exchanges' | 'whatsapp' | 'faq' | 'chat' | 'orders' | 'schedules'

export const MODULE_TITLES = {
  general: 'Como podemos ajudar?',
} as const

export const DEFAULT_MODULES = [
  { id: 'orders', icon: 'truck', title: 'Acompanhar pedido', isAvailable: true },
  { id: 'schedules', icon: 'petz-calendar', title: 'Consultar agendamentos', isAvailable: true },
] as const

export const UI_DELAYS = {
  contentShow: 400,
} as const
